import styles from './ImportanceOfDesignSystem.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const ImportanceOfDesignSystem: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>デザインシステムの重要性</h2>
      <div className={`${styles.importance}`}>
        <p>
          VUCAと言われる社会の中では、変化に素早く対応するスピード、すなわち、利用者により良い体験を素早く提供することが重要です。現在のデジタルプロダクトの世界では、全く新しい物を生み出すよりも、既にあるものを上手く活用して最適化を繰り返すことが重要といえます。
        </p>
        <p>
          そうした状況の中で企業は、複数のプロダクト・複数の部署・複数のデザイナーが一貫性のあるUIデザインを素早く的確に適用しなければなりません。この課題を解決するために、デザインシステムの導入が求められています。デザインシステムを導入することで、企業はUIデザインの内製化を進めることができ、一貫性のあるデザインを迅速に展開することが可能になります。
        </p>
        <p>
          デザインシステムによって内製化が進むと、複数のプロダクトや部署でのコラボレーションが容易になり、全体としてのデザイン品質が向上します。このように、デザインシステムはUIデザインの内製化支援を強力にサポートし、企業が変化に迅速に対応するための重要な手段となります。
        </p>
      </div>
      <dl className={styles.related}>
        <dt className={styles.related__title}>関連記事</dt>
        <dd className={styles.related__cts}>
          <p className={styles.related__cts__text}>
            <a
              className={styles.related__cts__text__inpocket}
              href="https://www.i3design.jp/in-pocket/designsystem-efficiency-costreduction/"
            >
              効率化とコスト削減を叶えるデザインシステムの力：企業が知っておくべきポイント
            </a>
          </p>
          <p className={styles.related__cts__text}>
            <a
              className={styles.related__cts__text__inpocket}
              href="https://www.i3design.jp/in-pocket/global-design-system/"
            >
              グローバルデザインシステムから考えるデザインシステムの未来
            </a>
          </p>
        </dd>
      </dl>
    </section>
  )
}

export default ImportanceOfDesignSystem
